import React, { PropsWithChildren } from "react";
import Navbar from "./navbar";
import Footer from "./footer";

interface IProps extends PropsWithChildren {
  title?: string;
}

const AppLayout = ({ children }: IProps) => {
  return (
    <div>
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};

export default AppLayout;
